import { useMutation } from "@tanstack/react-query";
import { deleteFaq } from "../api/deleteFaq";
import {
  getFaqsListByFaqGroupQueryData,
  invalidateFaqsListByFaqGroupQuery,
  setFaqsListByFaqGroupQueryData,
} from "../queries/useFaqsListByFaqGroupQuery";
import { FaqData } from "../types";

type Params = {
  faqGroupId: string;
  faqId: string;
  faqsList: FaqData[];
  onSuccess: () => void;
};

export const useDeleteFaqMutation = () => {
  return useMutation({
    mutationFn: async ({ faqGroupId, faqId, faqsList }: Params) => {
      const updatedFaqsList = faqsList.filter(({ id }) => id !== faqGroupId);

      const prevData = getFaqsListByFaqGroupQueryData(faqGroupId);

      setFaqsListByFaqGroupQueryData(faqGroupId, updatedFaqsList);

      await deleteFaq({
        faqGroupId: faqGroupId,
        faqId: faqId,
      });

      return prevData;
    },
    onSettled: (_, _error, { faqGroupId, onSuccess }) => {
      invalidateFaqsListByFaqGroupQuery(faqGroupId);
      onSuccess();
    },
  });
};
